import { render, staticRenderFns } from "./Informacion.vue?vue&type=template&id=6a4f0708&scoped=true&"
import script from "./Informacion.vue?vue&type=script&lang=js&"
export * from "./Informacion.vue?vue&type=script&lang=js&"
import style0 from "./Informacion.vue?vue&type=style&index=0&id=6a4f0708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f0708",
  null
  
)

export default component.exports